document.addEventListener('DOMContentLoaded', () => {
    if (window.innerWidth > 1024) { 
        document.addEventListener('mousemove', parallax);
    }
});

function parallax(e) {
    document.querySelectorAll('main .parallax').forEach(layer => {
        const speed = layer.getAttribute('data-speed');
        const x = (window.innerWidth - e.pageX * speed * 1.5) / 100;
        const y = (window.innerHeight - e.pageY * speed * 1.5) / 100;
         layer.style.transform = `translate(${x}px, ${y}px)`;
    });
}
